export default "__VITE_ASSET__58d9dcfc__"